import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import * as React from 'react';
import clsx from 'clsx';
import { Svg } from '@gandi/ui';
var styles = {
  "root": "Intro-root_2EIDq",
  "head": "Intro-head_2u6aJ",
  "icon": "Intro-icon_1Z1XD",
  "title": "Intro-title_O0w0y",
  "sticky": "Intro-sticky_FKDtR",
  "justifyContentCenter": "Intro-justifyContentCenter_3L3cV",
  "centered": "Intro-centered_lpOWz"
};
function Intro(_ref) {
  var icon = _ref.icon,
    prefix = _ref.prefix,
    title = _ref.title,
    sticky = _ref.sticky,
    _ref$centered = _ref.centered,
    centered = _ref$centered === void 0 ? true : _ref$centered,
    children = _ref.children,
    className = _ref.className;
  var hasIcon = !!icon && Svg.has(icon);
  var rootClasses = clsx(styles.root, _defineProperty({}, styles.sticky, sticky), className);
  var headerClasses = clsx(styles.head, _defineProperty({}, styles.justifyContentCenter, centered));
  var titleClasses = clsx(styles.title, _defineProperty({}, styles.centered, !hasIcon && !prefix));
  return /*#__PURE__*/React.createElement("div", {
    className: rootClasses
  }, /*#__PURE__*/React.createElement("header", {
    className: headerClasses
  }, prefix, icon && hasIcon && /*#__PURE__*/React.createElement(Svg, {
    name: icon,
    className: styles.icon
  }), /*#__PURE__*/React.createElement("h1", {
    className: titleClasses
  }, title)), children);
}
export default Intro;